import {ChangeDetectorRef, Component, OnInit, Input, Output, EventEmitter} from "@angular/core";
import {ApiService} from "~/app/core/api.service";
import {OfferService} from "~/app/core/offer-service/offer.service";
import {DomSanitizer} from "@angular/platform-browser";
import {HomeComponent} from "~/app/components/home/home.component";
import {OfferListHorizontalComponent} from "~/app/components/offer-list-horizontal/offer-list-horizontal.component";

@Component({
    selector: "categories-list-horizontal",
    templateUrl: "./categories-list-horizontal.component.html",
    styleUrls: ["./categories-list-horizontal.component.scss"]
})
export class CategoriesListHorizontalComponent implements OnInit {
  @Input() data: object;
  @Output() new_category = new EventEmitter<string>();
  @Output() new_sub = new EventEmitter<string>();
  @Output() free_only_checked = new EventEmitter<boolean>();
  categories: string[];
  prefix: string = "Main_Categories";
  freeOnly: boolean = false;

  on_click (value: string) {
    if (this.prefix !== "Main_Categories" && value !== 'Back') {
      this.new_sub.emit(value);
    }
    if (this.prefix === "Main_Categories") {
      this.prefix = value;
      this.new_category.emit(this.prefix);
      this.new_sub.emit('');
      this.new_prefix();
      this.refresh();
    }
    if (value === 'Back') {
      this.prefix = "Main_Categories";
      this.new_category.emit('');
      this.new_sub.emit('');
      this.new_prefix();
      this.refresh();
    }
  }
  category_prefix: string = '';
  // offers: { company: String, name: String, image: String }[] = [];
  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly offerService: OfferService,
    private sanitizer: DomSanitizer,
    private homeComponent: HomeComponent
  ) {
  }

  ngOnInit(): void {
    this.new_prefix();
    this.refresh();
  }

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  prefect_category(category) {
    // strip off prefix and suffix, and do a pretty reformat
    let newName = category.split('.')[0];
    newName = newName.match(/[a-zA-Z&]\s|[a-zA-Z&]/mg).join('');
    if (newName === "Business Education Consulting") {
      newName = "Business Education / Consulting"
    }
    return newName;
  }
  new_prefix() {
    this.category_prefix = "assets/SVG/" + this.prefix + "/";
  }
  refresh() {
    // this.categories = this.data[this.prefix];
    let categories: string[] = [];
    console.log("loadedOfferCategories: ");
    console.log(this.homeComponent.loadedOfferCategories);

    for (let cat of this.data[this.prefix]) {
      console.log("cat: " + this.prefect_category(cat));
      if (this.homeComponent.loadedOfferCategories.has(this.prefect_category(cat)))
        categories.push(cat);
    }
    this.categories = categories;
    console.log(this.categories);
  }

  categorySelected(category: string) {
    return this.homeComponent.subCategory.indexOf(this.prefect_category(category)) > -1;
  }

  toggle_free() {
    this.freeOnly = !this.freeOnly;
    this.free_only_checked.emit(this.freeOnly);
  }

  freeSelected() {
    return this.freeOnly;
  }
}
